export * from './icon-access-key.component';
